import { LinearProgress } from '@material-ui/core'
import { LinearProgressProps } from '@material-ui/core/LinearProgress'

interface Props extends LinearProgressProps{
  project: Project
}

const ProjectProgressBar = ({ project,  ...restProps }: Props) => {
  let value = 100
  let color: LinearProgressProps['color'] = 'secondary'

  switch (project.status) {
    case 'New':
      value = 100 * (1 / 6)
      break

    case 'Submitted for review':
      value = 100 * (2 / 6)
      break

    case 'Quote submitted':
      value = 100 * (3 / 6)
      break

    case 'In progress':
      value = 100 * (4 / 6)
      color = 'primary'
      break

    case 'Pending acceptance':
      value = 100 * (5 / 6)
      color = 'primary'
      break

    case 'Complete':
      value = 100
      color = 'primary'
      break

    default:
      value = 100
      color = 'primary'
  }

  return (
    <LinearProgress
      variant="determinate"
      value={value}
      color={color}
      {...restProps}
    />
  )
}

export default ProjectProgressBar
